<template>
	<!-- <div> -->
	<el-carousel :interval="5000" arrow="always" style="height:400px;">
		<el-carousel-item v-for="slider in sliders" :key="slider" style="height:400px;">
			<div class="imgSlider" :style="{ 'background': 'url(' + slider + ')' }"></div>
		</el-carousel-item>
	</el-carousel>
	<!-- </div> -->
</template>
<script>
import { mapState, mapGetters } from "vuex";

export default {
	name: "xd-swiper",
	data() {
		return {
			sliders: []
		};
	},
	mounted() {
		if (this.appweb.sliders.length > 0) {
			this.sliders = this.appweb.sliders;
		}
	},
	methods: {},
	computed: {
		...mapState(["appweb"])
	},
	watch: {
		appweb: function(val) {
			this.sliders = val.sliders;
		}
	}
};
</script>
<style scoped>
.imgSlider {
	background-size: cover !important;
	background-position: center center !important;
	background-repeat: no-repeat !important;
	height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/xd-swiper.vue